// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB1k6ZskfBbppV9TSqK09IefrK9JSmnkgc",
  authDomain: "gliatech-hub.firebaseapp.com",
  databaseURL:
    "https://gliatech-hub-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gliatech-hub",
  storageBucket: "gliatech-hub.firebasestorage.app",
  messagingSenderId: "614246751194",
  appId: "1:614246751194:web:d4036161b30151410dfee3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const database = getDatabase(app);
export { auth, firestore, storage, database };
